// import axios from "axios";
// import {apiBuyerStatusUrl, apiHscClosingUrl, apiListedClosedUrl, apiNegUCUrl, apiOffMarketSellerUrl, apiReferralClosingUrl} from "./apiBaseUrls";
// import {executeQuery} from "./executeQuery";
// import {
//     GET_HSC_CLOSINGS,
//     GET_OFF_MARKET_SELLERS,
//     GET_REFERRAL_CLOSINGS,
//     JUST_LISTED_JUST_CLOSED_PROPERTY,
//     NEGOTIATION_UNDER_CONTRACT_PROPERTY,
//     PROPERTY_DATA_DEFAULT_EMAIL
// } from "../consts/queries";
// import {formatName} from "../utils";
// import {emailEnv, env} from '../consts/env';
// import { dateISOtoUS } from "../date-converter";

// export function sendBuyerEmail(res) {
//     if (env) return;

//     axios({
//         method: 'post',
//         url: apiBuyerStatusUrl,
//         headers: {'Accept': '*'},
//         data: {
//             STATUS: res.STATUS,
//             CATEGORY: res.CATEGORY,
//             TYPE: res.TYPE,
//             MARKET: res.MARKET,
//             TENANT_SUBCATEGORY: res.TENANT_SUBCATEGORY,
//             PRICE_MIN: res.PRICE_MIN,
//             PRICE_MAX: res.PRICE_MAX,
//             CAP_RATE_MIN: res.CAP_RATE_MIN,
//             CAP_RATE_MAX: res.CAP_RATE_MAX,
//             STRIVE_AGENT: res.STRIVE_AGENT,
//             NOTES: res.NOTES,
//             LINK: res.LINK,
//             EMAIL_ENV: '',
//         },
//     });
// }

// export function sendListedClosedEmail(property) {
//     if (env) return;

//     executeQuery({
//         queryName: JUST_LISTED_JUST_CLOSED_PROPERTY,
//         params: {
//             PROPERTY_ID: property.ARCIMEDES_ROW_ID,
//         }
//     }).then(data => {
//         if (data.success && data.data.length) {
//             axios({
//                 method: 'post',
//                 url: apiListedClosedUrl,
//                 headers: {'Accept': '*'},
//                 data: {
//                     propertyId: property.ARCIMEDES_ROW_ID,
//                     status: property.STATUS,
//                     data: {
//                         ...data.data[0],
//                         LINK: property.LINK,
//                     },
//                     EMAIL_ENV: '',
//                 },
//             });
//         }
//     });
// }

// export function sendNegotiationUnderContractEmail(property) {
//     if (env) return;

//     executeQuery({
//         queryName: NEGOTIATION_UNDER_CONTRACT_PROPERTY,
//         params: {
//             PROPERTY_ID: property.ARCIMEDES_ROW_ID,
//         }
//     })
//     .then(res => {
//         if (res.success && res.data.length) {
//             axios({
//                 method: 'post',
//                 url: apiNegUCUrl,
//                 headers: {'Accept': '*'},
//                 data: {
//                     STATUS: res.data[0].STATUS,
//                     NAME: res.data[0].NAME,
//                     CITY: res.data[0].CITY,
//                     STATE: res.data[0].STATE,
//                     NEGOTIATION_PRICE: res.data[0].NEGOTIATION_PRICE,
//                     CAP_RATE: res.data[0].NEGOTIATION_CAP_RATE,
//                     AGENT_NAME: res.data[0].BUYER_AGENT_FIRST_NAME ? formatName(res.data[0], 'BUYER_AGENT_') : formatName(res.data[0], 'AGENT_'),
//                     BUYER_NAME: formatName(res.data[0], 'BUYER_'),
//                     LINK: property.LINK,
//                     EMAIL_ENV: '',
//                 },
//             });
//         }
//     });
// }

// export function sendDefaultEmail(property, url) {
//     if (env) return;

//     executeQuery({
//         queryName: PROPERTY_DATA_DEFAULT_EMAIL,
//         params: {
//             PROPERTY_ID: property.ARCIMEDES_ROW_ID,
//         }
//     }).then(res => {
//         if (res.success && res.data.length) {
//             axios({
//                 method: 'post',
//                 url: url,
//                 headers: {'Accept': '*'},
//                 data: {
//                     PROPERTY_ID: res.data[0].ARCIMEDES_ROW_ID,
//                     STATUS: res.data[0].STATUS,
//                     NAME: res.data[0].NAME,
//                     CITY: res.data[0].CITY,
//                     STATE: res.data[0].STATE,
//                     LIST_PRICE: res.data[0].LIST_PRICE,
//                     CAPITALIZATION_RATE: res.data[0].CAPITALIZATION_RATE,
//                     AGENT_1_FIRST_NAME: res.data[0].AGENT_1_FIRST_NAME,
//                     AGENT_1_LAST_NAME: res.data[0].AGENT_1_LAST_NAME,
//                     AGENT_2_FIRST_NAME: res.data[0].AGENT_2_FIRST_NAME,
//                     AGENT_2_LAST_NAME: res.data[0].AGENT_2_LAST_NAME,
//                     AGENT_3_FIRST_NAME: res.data[0].AGENT_3_FIRST_NAME,
//                     AGENT_3_LAST_NAME: res.data[0].AGENT_3_LAST_NAME,
//                     LINK: property.LINK,
//                     EMAIL_ENV: '',
//                 },
//             });
//         }
//     });
// }

// export function sendHscClosingEmail(property) {
//     if (env) return;

//     executeQuery({
//         queryName: GET_HSC_CLOSINGS,
//         params: {
//             PROPERTY_ID: property.ARCIMEDES_ROW_ID,
//         }
//     }).then(res => {
//         if (res.success && res.data.length) {
//             const data = {
//                 ...res.data[0],
//                 REFERRED_BY: res.data[0].TEAM_FIRST_NAME ? formatName(res.data[0], 'TEAM_') : res.data[0].OUTSIDE_AGENT ? 'Outside Agent' : '',
//                 LINK: property.LINK,
//                 EMAIL_ENV: '',
//             };
//             delete data.OUTSIDE_AGENT;
//             delete data.TEAM_FIRST_NAME;
//             delete data.TEAM_LAST_NAME;
//             axios({
//                 method: 'post',
//                 url: apiHscClosingUrl,
//                 headers: {'Accept': '*'},
//                 data,
//             });
//         }
//     });
// }

// export function sendReferralClosingEmail(property) {
//     if (env) return;

//     executeQuery({
//         queryName: GET_REFERRAL_CLOSINGS,
//         params: {
//             PROPERTY_ID: property.ARCIMEDES_ROW_ID,
//         }
//     }).then(res => {
//         if (res.success && res.data.length) {
//             const data = {
//                 ...res.data[0],
//                 AGENT_NAME: res.data[0].TEAM_FIRST_NAME ? formatName(res.data[0], 'TEAM_') : '',
//                 CLOSE_OF_ESCROW: dateISOtoUS(res.data[0].CLOSE_OF_ESCROW),
//                 LINK: property.LINK,
//                 EMAIL_ENV: '',
//             };

//             delete data.TEAM_FIRST_NAME;
//             delete data.TEAM_LAST_NAME;

//             axios({
//                 method: 'post',
//                 url: apiReferralClosingUrl,
//                 headers: {'Accept': '*'},
//                 data,
//             });
//         }
//     });
// }


// export function sendOffMarketSellerEmail(property) {
//     if (env) return;

//     let buildingType;
//     switch(property.CATEGORY) {
//         case 'retail':
//             buildingType = property.NAME;
//             break;
//         case 'office':
//             buildingType = (property.TYPE && property.TYPE === 'STNL' ? 'A single-tenant office' : 'Office') + ' building';
//             break;
//         case 'industrial':
//             buildingType = (property.TYPE && property.TYPE === 'STNL' ? 'A single-tenant' : 'Multi-Tenant ') + ' industrial building';
//             break;
//         default:
//             break;
//     }

//     executeQuery({
//         queryName: GET_OFF_MARKET_SELLERS,
//         params: {
//             PROPERTY_ID: property.ARCIMEDES_ROW_ID,
//         }
//     }).then(res => {
//         if (res.success && res.data.length) {
//             const data = {
//                 ...res.data[0],
//                 BUILDING_TYPE: buildingType,
//                 LINK: property.LINK,
//                 EMAIL_ENV: '',
//             };

//             delete data.TYPE;
//             delete data.CATEGORY;
//             // console.log(data)
//             if(data.AGENT_FIRST_NAME && data.AGENT_LAST_NAME &&  data.NAME && data.ADDRESS && data.CITY && data.STATE && data.BUILDING_TYPE && data.CAP_RATE){
//                 axios({
//                     method: 'post',
//                     url: apiOffMarketSellerUrl,
//                     headers: {'Accept': '*'},
//                     data,
//                 });
//             } else {
//                 return 'missing information'
//             }
//         }
//     });
// }

// new code

import axios from "axios";
import {apiBuyerStatusUrl, apiHscClosingUrl, apiListedClosedUrl, apiNegUCUrl, apiOffMarketSellerUrl, apiReferralClosingUrl} from "./apiBaseUrls";
import {executeQuery} from "./executeQuery";
import {
    GET_HSC_CLOSINGS,
    GET_OFF_MARKET_SELLERS,
    GET_REFERRAL_CLOSINGS,
    JUST_LISTED_JUST_CLOSED_PROPERTY,
    NEGOTIATION_UNDER_CONTRACT_PROPERTY,
    PROPERTY_DATA_DEFAULT_EMAIL
} from "../consts/queries";
import {formatName} from "../utils";
import {emailEnv, env} from '../consts/env';
import { dateISOtoUS } from "../date-converter";
import { GET_HSC_CLOSINGS_QUERY, GET_OFF_MARKET_SELLERS_QUERY, GET_REFERRAL_CLOSINGS_QUERY, JUST_LISTED_JUST_CLOSED_PROPERTY_QUERY, NEGOTIATION_UNDER_CONTRACT_PROPERTY_QUERY, PROPERTY_DATA_DEFAULT_EMAIL_QUERY } from "../components/Graphql/Queries/emailRequestQUery";
import { fetchData, mutateData } from "../components/Service/graphQlService";
import { SEND_EMAIL_NOTIFICATION } from "../components/Graphql/MailQueries/sendEmalNotification";

export function sendBuyerEmail(res) {
    if (env) return;

    axios({
        method: 'post',
        url: apiBuyerStatusUrl,
        headers: {'Accept': '*'},
        data: {
            STATUS: res.status,
            CATEGORY: res.category,
            TYPE: res.type,
            MARKET: res.market,
            TENANT_SUBCATEGORY: res.tenant_subcategory,
            PRICE_MIN: res.price_min,
            PRICE_MAX: res.price_max,
            CAP_RATE_MIN: res.cap_rate_min,
            CAP_RATE_MAX: res.cap_rate_max,
            STRIVE_AGENT: res.strive_agent,
            NOTES: res.notes,
            LINK: res.LINK,
            EMAIL_ENV: '',
        },
    });
}

export function sendListedClosedEmail(property,client) {
    if (env) return;
    
    // executeQuery({
    //     queryName: JUST_LISTED_JUST_CLOSED_PROPERTY,
    //     params: {
    //         PROPERTY_ID: property.ARCIMEDES_ROW_ID,
    //     }
    // })
    //const token = localStorage.getItem('authToken');

    // client.query({query: JUST_LISTED_JUST_CLOSED_PROPERTY_QUERY,variables:{propertyId: property.arcimedes_row_id},
    //     fetchPolicy: "no-cache",
    //     context: {
    //       headers: {
    //         authorization: `Bearer ${token}`,
    //       }}
    //     })
        fetchData(JUST_LISTED_JUST_CLOSED_PROPERTY_QUERY,{propertyId: property.arcimedes_row_id})
    .then(data => {
        if (data.justListedJustClosedProperty.length > 0) {
            axios({
                method: 'post',
                url: apiListedClosedUrl,
                headers: {'Accept': '*'},
                data: {
                    propertyId: property.arcimedes_row_id,
                    status: property.status,
                    data: {
                        ...data.justListedJustClosedProperty[0],
                        LINK: property.LINK,
                    },
                    EMAIL_ENV: '',
                },
            });
        }
    });
}

export function sendNegotiationUnderContractEmail(property,client) {
    if (env) return;

    // executeQuery({
    //     queryName: NEGOTIATION_UNDER_CONTRACT_PROPERTY,
    //     params: {
    //         PROPERTY_ID: property.ARCIMEDES_ROW_ID,
    //     }
    // })
    // const token = localStorage.getItem('authToken');

    // client.query({query: NEGOTIATION_UNDER_CONTRACT_PROPERTY_QUERY,variables:{propertyId: property.arcimedes_row_id},
    //     fetchPolicy: "no-cache",
    //     context: {
    //       headers: {
    //         authorization: `Bearer ${token}`,
    //       }}
    //     })
        fetchData(NEGOTIATION_UNDER_CONTRACT_PROPERTY_QUERY,{propertyId: property.arcimedes_row_id})
        .then(res => {
        if (res.data.negotiationUnderContractProperty.length > 0) {
            axios({
                method: 'post',
                url: apiNegUCUrl,
                headers: {'Accept': '*'},
                data: {
                    STATUS: res.data.negotiationUnderContractProperty[0].status,
                    NAME: res.data.negotiationUnderContractProperty[0].name,
                    CITY: res.data.negotiationUnderContractProperty[0].city,
                    STATE: res.data.negotiationUnderContractProperty[0].state,
                    NEGOTIATION_PRICE: res.data.negotiationUnderContractProperty[0].negotiation_price,
                    CAP_RATE: res.data.negotiationUnderContractProperty[0].negotiation_cap_rate,
                    AGENT_NAME: res.data.negotiationUnderContractProperty[0].buyer_first_name ? formatName(res.data.negotiationUnderContractProperty[0], 'buyer_agent_') : formatName(res.data.negotiationUnderContractProperty[0], 'agent_'),
                    BUYER_NAME: formatName(res.data.negotiationUnderContractProperty[0], 'buyer_'),
                    LINK: property.LINK,
                    EMAIL_ENV: '',
                },
            });
        }
    });
}

export function sendDefaultEmail(property, url,client) {
    if (env) return;

    // executeQuery({
    //     queryName: PROPERTY_DATA_DEFAULT_EMAIL,
    //     params: {
    //         PROPERTY_ID: property.ARCIMEDES_ROW_ID,
    //     }
    // })
    // client.query({query: PROPERTY_DATA_DEFAULT_EMAIL_QUERY,variables:{propertyId: property.arcimedes_row_id},
    //     fetchPolicy: "no-cache",
    //     context: {
    //       headers: {
    //         authorization: `Bearer ${token}`,
    //       }}
    //     })
        fetchData(PROPERTY_DATA_DEFAULT_EMAIL_QUERY,{propertyId: property.arcimedes_row_id})
        .then(res => {
        if (res.data.propertyDataDefaultEmail.length > 0 ) {
            axios({
                method: 'post',
                url: url,
                headers: {'Accept': '*'},
                data: {
                    PROPERTY_ID: res.data.propertyDataDefaultEmail[0].arcimedes_row_id,
                    STATUS: res.data.propertyDataDefaultEmail[0].status,
                    NAME: res.data.propertyDataDefaultEmail[0].name,
                    CITY: res.data.propertyDataDefaultEmail[0].city,
                    STATE: res.data.propertyDataDefaultEmail[0].state,
                    LIST_PRICE: res.data.propertyDataDefaultEmail[0].list_price,
                    CAPITALIZATION_RATE: res.data.propertyDataDefaultEmail[0].capitalization_rate,
                    AGENT_1_FIRST_NAME: res.data.propertyDataDefaultEmail[0].agent_1_first_name,
                    AGENT_1_LAST_NAME: res.data.propertyDataDefaultEmail[0].agent_1_last_name,
                    AGENT_2_FIRST_NAME: res.data.propertyDataDefaultEmail[0].agent_2_first_name,
                    AGENT_2_LAST_NAME: res.data.propertyDataDefaultEmail[0].agent_2_last_name,
                    AGENT_3_FIRST_NAME: res.data.propertyDataDefaultEmail[0].agent_3_first_name,
                    AGENT_3_LAST_NAME: res.data.propertyDataDefaultEmail[0].agent_3_last_name,
                    LINK: property.LINK,
                    EMAIL_ENV: '',
                },
            });
        }
    });
}

export function sendHscClosingEmail(property,client) {
    if (env) return;
    // executeQuery({
    //     queryName: GET_HSC_CLOSINGS,
    //     params: {
    //         PROPERTY_ID: property.ARCIMEDES_ROW_ID,
    //     }
    // })
	// 	const token = localStorage.getItem('authToken');

    // client.query({query: GET_HSC_CLOSINGS_QUERY,variables:{arcimedesRowId: property.arcimedes_row_id},
    //     fetchPolicy: "no-cache",
    //     context: {
    //       headers: {
    //         authorization: `Bearer ${token}`,
    //       }}
    //     })
        fetchData(GET_HSC_CLOSINGS_QUERY,{arcimedesRowId: property.arcimedes_row_id})
    .then(res => {
        if (res.data.getHscClosing !== null) {
            const data = {
                ...res.data.getHscClosing,
                REFERRED_BY:res.data.getHscClosing ? res.data.getHscClosing.referred_by: '',
                LINK: property.LINK,
                EMAIL_ENV: '',
            };
            delete data.outside_agent;
            delete data.team_first_name;
            delete data.team_last_name;
            axios({
                method: 'post',
                url: apiHscClosingUrl,
                headers: {'Accept': '*'},
                data,
            });
        }
    });
}

export function sendReferralClosingEmail(property,client) {
    if (env) return;

    // executeQuery({
    //     queryName: GET_REFERRAL_CLOSINGS,
    //     params: {
    //         PROPERTY_ID: property.ARCIMEDES_ROW_ID,
    //     }
    // })
	// 	const token = localStorage.getItem('authToken');
    // client.query({query: GET_REFERRAL_CLOSINGS_QUERY,variables:{arcimedesRowId: property.arcimedes_row_id},
    //     fetchPolicy: "no-cache",
    //     context: {
    //       headers: {
    //         authorization: `Bearer ${token}`,
    //       }}
    //     })
        fetchData(GET_REFERRAL_CLOSINGS_QUERY,{arcimedesRowId: property.arcimedes_row_id})
    .then(res => {
        if (res.data.getReferralClosing  !== null) {
            const data = {
                ...res.data.getReferralClosing,
                AGENT_NAME: res.data.getReferralClosing ?  res.data.getReferralClosing.agent_name : '',
                CLOSE_OF_ESCROW: dateISOtoUS(res.data.getReferralClosing.close_of_escrow),
                LINK: property.LINK,
                EMAIL_ENV: '',
            };

            delete data.team_first_name;
            delete data.team_last_name;

            axios({
                method: 'post',
                url: apiReferralClosingUrl,
                headers: {'Accept': '*'},
                data,
            });
        }
    });
}


export function sendOffMarketSellerEmail(property,client) {
    if (env) return;

    let buildingType;
    switch(property.category) {
        case 'retail':
            buildingType = property.name;
            break;
        case 'office':
            buildingType = (property.type && property.type === 'STNL' ? 'A single-tenant office' : 'Office') + ' building';
            break;
        case 'industrial':
            buildingType = (property.type && property.type === 'STNL' ? 'A single-tenant' : 'Multi-Tenant ') + ' industrial building';
            break;
        default:
            break;
    }

    // executeQuery({
    //     queryName: GET_OFF_MARKET_SELLERS,
    //     params: {
    //         PROPERTY_ID: property.ARCIMEDES_ROW_ID,
    //     }
    // })
		const token = localStorage.getItem('authToken');

    // client.query({query: GET_OFF_MARKET_SELLERS_QUERY,variables:{arcimedesRowId: property.arcimedes_row_id},
    //     fetchPolicy: "no-cache",
    //     context: {
    //       headers: {
    //         authorization: `Bearer ${token}`,
    //       }}
    //     })
        fetchData(GET_OFF_MARKET_SELLERS_QUERY,{arcimedesRowId: property.arcimedes_row_id})
    .then(res => {
        if (res.data.getOffMarketSeller !== null) {
            const data = {
                ...res.data.getOffMarketSeller ,
                BUILDING_TYPE: buildingType,
                LINK: property.LINK,
                EMAIL_ENV: '',
            };

            delete data.type;
            delete data.category;
            // console.log(data)
            if(data.agent_first_name && data.agent_last_name &&  data.name && data.address && data.city && data.state && data.building_type && data.cap_rate){
                axios({
                    method: 'post',
                    url: apiOffMarketSellerUrl,
                    headers: {'Accept': '*'},
                    data,
                });
            } else {
                return 'missing information'
            }
        }
    });
}

export function sendEmailNotification(data={}){
    //restrict emails for dev environments
    if (env) return;

    return mutateData(SEND_EMAIL_NOTIFICATION, { input:data})
}